module.exports = __webpack_public_path__ + "static/media/wom-mas-libre.a0ea097d.svg";